import React from 'react';
import { BookOpen } from 'lucide-react';

const BookHero = () => {
  return (
    <section className="relative py-32 bg-slate-900">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <BookOpen className="w-16 h-16 text-amber-400 mx-auto mb-6" aria-hidden="true" />
        <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6">
          My Books
        </h1>
        <p className="text-xl text-slate-300 max-w-2xl mx-auto">
          Satire with a reporter&apos;s eye and a comedian&apos;s timing
        </p>
      </div>
    </section>
  );
};

export default BookHero;
